export default "__VITE_ASSET__95701c13__"